module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lines_layer_off-d7c59693c978fa0f8156f2e4d525bd7a.jpg";